/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { contactService } from 'services'

const initialState = {
  key: '',
  locked: false,
  stage: 'initial',
  history: [],
  data: {},
  onClose: null,
  dashboardModals: {
    openObjection: false,
    openContactUpdate: false,
    openMessages: false,
    isOpen: false,
    isLoadingContactUpdate: true,
    hasLoadedModalInfo: false,
  },
}

const { getAlreadyOpenContactUpdateModal } = contactService()

export const fetchContactUpdate = createAsyncThunk(
  'modal/contactUpdate',
  async (contractId, { rejectWithValue }) => {
    try {
      const { data } = await getAlreadyOpenContactUpdateModal(contractId)

      return data.visualized
    } catch (error) {
      return rejectWithValue()
    }
  }
)

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    setModal: (state, action) => {
      if (action.payload.key === '') state.dashboardModals.isOpen = false
      state.key = action.payload.key
      state.locked = action.payload.locked
      state.stage = action.payload.stage || 'initial'
      state.history = []
      state.data = action.payload.data
      state.onClose = null
    },
    setModalOnClose: (state, action) => {
      state.onClose = action.payload
    },
    setStage: (state, action) => {
      state.history.push(state.stage)
      state.stage = action.payload
    },
    goBack: state => {
      const stage = state.history.pop()
      state.stage = stage
    },
    setDashboardModalOpen: (state, action) => {
      state.dashboardModals.isOpen = action.payload
    },
    setDashboardModals: (state, action) => {
      const { openObjection, openContactUpdate, openMessages } = action.payload

      state.dashboardModals.openObjection = openObjection
      state.dashboardModals.openContactUpdate = openContactUpdate
      state.dashboardModals.openMessages = openMessages
    },
    setHasLoadedModalInfo: (state, action) => {
      state.dashboardModals.hasLoadedModalInfo = action.payload
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchContactUpdate.fulfilled, (state, action) => {
        state.dashboardModals.openContactUpdate = !action.payload
        state.dashboardModals.isLoadingContactUpdate = false
      })
      .addCase(fetchContactUpdate.rejected, state => {
        state.dashboardModals.openContactUpdate = false
        state.dashboardModals.isLoadingContactUpdate = false
      })
  },
})

export const {
  setModal,
  setModalOnClose,
  setStage,
  goBack,
  setDashboardModals,
  setDashboardModalOpen,
  setHasLoadedModalInfo,
} = modalSlice.actions

export default modalSlice.reducer
